import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './routers.js'
import {
  firstUpperCase
} from '@/common/form_validate'
import store from '@/store'

Vue.use(VueRouter)
const router = new VueRouter(routers)

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const appName = process.env.DF_PLATFORM === 'datahub' ? 'Datahub' : 'Dotflow'
  document.title = to.name ? appName + ' - ' + firstUpperCase(to.name) : appName // 设置浏览器tab名称

  let profile = store.getters.profile
  if (!profile && to.name !== 'login') {
    next({ name: 'login' })
  }

  next()
})

// 全局后置守卫
// router.afterEach(() => {})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js